import { alpha } from '@material-ui/core/styles/colorManipulator';
import { DefaultTheme } from '@material-ui/styles';

export const getDefaultOptions = config => {
    return {
        cloud_name: config.cloudinaryCloudName,
        upload_preset: config.cloudinaryUploadPreset,
        croppingAspectRatio: 0.99999, //TODO: why?
        maxImageWidth: 750,
        showSkipCropButton: false,
        cropping: true,
        transformation: 'q_auto:best,c_crop,g_custom',
        clientAllowedFormats: ['jpeg', 'gif', 'png', 'bmp', 'ico'],
        sources: ['local', 'camera', 'google_drive', 'dropbox'],
        resourceType: 'image',
    };
};

export const getCustomStyles = (theme: DefaultTheme) => {
    return {
        styles: {
            frame: {
                background: alpha(theme.palette.greys[700], 0.4),
            },
            palette: {
                sourceBg: '#FFFFFF',
                windowBorder: theme.palette.greys[500],
                tabIcon: theme.customization.interactive.C10,
                inactiveTabIcon: theme.palette.greys[500],
                link: theme.customization.interactive.C10,
                action: theme.customization.interactive.C10,
                inProgress: theme.customization.interactive.C10,
            },
        },
    };
};
